export default "/images/c352bc69b3879afa7ca784545c26937b.avif";